import LocalizedStrings from "react-localization"
import english from "./en"
import spanish from "./es"
const strings = new LocalizedStrings({
  es: spanish,
  en: english,
 
})
export default strings
